import {queryFeatures} from "@esri/arcgis-rest-feature-service";
import {IExtent} from "@esri/arcgis-rest-common-types";
import VectorSource from "ol/source/Vector";
import {Options} from "ol/source/Vector";
import {EsriJSON} from "ol/format";
import {Geometry} from "ol/geom";

/**
 * ArcGISLazyVectorLayer extends OpenLayers' {VectorSource} to display
 * data hosted by an ArcGIS Feature Service.
 *
 * The layer will query the feature service for the FID of features that are
 * in the visible extent, and then load those features, only if they haven't
 * already been loaded, get a get feature request.
 */
export function arcgisLazyVectorSource(layerOptions: Options) : VectorSource<Geometry> {
    try {

        layerOptions.loader = () => {};
        let source = new VectorSource(layerOptions);
        let esriJSONFormat = new EsriJSON();

        let loading = {};

        let loadFeature = (fid: number, outSr: string = '3857') => {
            if (!loading[fid]) {
                loading[fid] = true;
                // getFeature doesn't allow us to specify the output projection,
                // so instead, we use queryFeatures with a where clause
                queryFeatures({
                    url: <string> source.getUrl(),
                    returnGeometry: true,
                    where: `FID=${fid}`,
                    outSR: outSr,
                    geometryPrecision: 0 // we're using NZTM, so round coordinates to nearest metre
                }).then((resp: any) => {
                    let f = esriJSONFormat.readFeature(resp.features[0]);
                    source.addFeature(f);
                }, (err) => {
                    console.log(`Failed to load feature ${fid} from ${source.getUrl()}`);
                    console.log(err);
                });
            }
        };

        (<any> source).setLoader(function(extentFromMap, resolution, projection) {
            // Load other layers first
            window.setTimeout(() => {
                let sr = projection.getCode().split(":")[1];
                queryFeatures({
                    url: <string> source.getUrl(),
                    returnGeometry: false,
                    spatialRel: 'esriSpatialRelIntersects',
                    geometry: <IExtent> {
                        xmin: extentFromMap[0],
                        ymin: extentFromMap[1],
                        xmax: extentFromMap[2],
                        ymax: extentFromMap[3],
                        spatialReference: {
                            wkid: sr
                        }
                    },
                    geometryType: "esriGeometryEnvelope",
                    // outFields: ['FID'],
                    returnIdsOnly: true,
                    outSR: sr
                }).then((resp : any) => {
                    resp.objectIds.forEach((fid) => loadFeature(fid, sr));
                });
            }, 0);
        });

        return source;
    } catch (e) {
        console.warn(e);
        throw e;
    }
}
